import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CheckINNResponse as SchemaCheckINNResponse } from '../schemas/CheckINNResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CheckStoreINNContentType = '' as const;
export type CheckStoreINNRequest = void;
export type CheckStoreINNResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful check of INN
     */
    '200': {
        'application/json': SchemaCheckINNResponse;
    };
};
export type CheckStoreINNResponseSuccess = CheckStoreINNResponses['200']['application/json'];
export type CheckStoreINNSearchParams = {
    inn: string;
};
export type CheckStoreINNPathParameters = undefined;
export const CheckStoreINNUrl = '/stores/check_inn' as const;
export const CheckStoreINNMethod = 'GET' as const;
export const getCheckStoreINNUrl = (_params?: CheckStoreINNPathParameters) => CheckStoreINNUrl;
